import React, {Component, useContext} from 'react';
import {get} from 'lodash';
import AbacusClientUtils from '@homeaway/abacus-client-utils';
import Feedback from '@homeaway/react-feedback';
import URLSearchParams from '@ungap/url-search-params';
import {matchPath, Route} from 'react-router-dom';
import {graphql} from 'react-apollo';
/* Molecules*/
import {Toaster} from '../molecules/baseline/baseline';
/* Organism */
import Inbox from '../organisms/Inbox/Inbox';

import {AppQuery} from './AppQuery';
import haWrapper from '../../utils/haWrapper';
import translate from '../../utils/translations';
import {isConfirmationToTIDRedirect} from '../../utils/confirmation';
import Confirmation from '../Confirmation/Confirmation';
import ConfirmationToTID from '../ConfirmationToTID/ConfirmationToTID';
import ConversationWrapper from '../Conversation/ConversationWrapper/ConversationWrapper';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import MyTrips from '../MyTrips/MyTrips';
import AppDownloadBanner from '../AppDownloadBanner/AppDownloadBanner';
import ScrollToTop from '../ScrollToTop/ScrollToTop';
import VrbexContext from '../../components/context/VrbexContext';

import './App.less';

export class AppInternal extends Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        AbacusClientUtils.evaluateExperimentAndLog('HA_STAY_AA_TEST');

        this.unlisten = this.props.history.listen(() => {
            haWrapper.userTiming.mark('page.unload');
        });
    }

    componentWillUnmount() {
        this.unlisten();
    }

    renderInbox = () => {
        const {isVrbexNative} = this.props;
        return (
            <Inbox
                isVrbexNative={isVrbexNative}
                page={1}
                pageSize={25}
                systemData={get(this.props, 'data.systemData', {})}
                translations={get(this.props, 'data.translations', {})}
            />
        );
    };

    renderConversation = (props) => {
        const activeTab = get(props, 'match.params.tab', 'details');
        const backUrl = get(
            props,
            'location.state.backUrl',
            '/traveler/th/inbox'
        );
        const conversationId = get(props, 'match.params.id', '');
        const guestsRoute = matchPath(get(props, 'location.pathname', ''), {
            path: '/traveler/th/inbox/conversation/:id/details/guests',
            exact: true,
            strict: true,
        });
        const search = get(props, 'location.search', '');
        const systemData = get(this.props, 'data.systemData', {});
        const tabChange = get(props, 'location.state.tabChange', false);
        const translations = get(this.props, 'data.translations', {});
        return (
            <ConversationWrapper
                activeTab={activeTab}
                backUrl={backUrl}
                conversationId={conversationId}
                isGuestModalOpen={guestsRoute ? true : false}
                path={get(this.props, 'location.pathname') || {}}
                search={search}
                systemData={systemData}
                tabChange={tabChange}
                translations={translations}
            />
        );
    };

    renderMyTrips = () => {
        return (
            <MyTrips
                systemData={get(this.props, 'data.systemData', {})}
                translations={get(this.props, 'data.translations', {})}
            />
        );
    };

    renderConfirmation = () => {
        const search = get(this.props, 'location.search', '');
        const params = new URLSearchParams(search);
        const reservationId = params.get('reservationId');
        const bookingFlow = params.get('bookingFlow');
        const unitLink = params.get('unitLink');
        const tripViewId = params.get('tripViewId');
        const tripItemId = params.get('tripItemId');
        const tripsSandbox = params.get('tripsSandbox');

        const {isUserLoggedIn} = this.props.data?.systemData || {};
        const {isVrbexNative, isConfirmationToTID} = this.props;

        if (
            isConfirmationToTIDRedirect(
                isConfirmationToTID,
                tripViewId,
                tripItemId
            )
        ) {
            return (
                <ConfirmationToTID
                    isVrbexNative={isVrbexNative}
                    isUserLoggedIn={isUserLoggedIn || false}
                    path={get(this.props, 'location.pathname')}
                    reservationId={reservationId}
                    systemData={get(this.props, 'data.systemData', {})}
                    translations={get(this.props, 'data.translations', {})}
                    unitLink={unitLink}
                    bookingFlow={bookingFlow}
                    tripViewId={tripViewId}
                    tripItemId={tripItemId}
                    tripsSandbox={tripsSandbox}
                />
            );
        }
        return (
            <Confirmation
                isVrbexNative={isVrbexNative}
                isUserLoggedIn={isUserLoggedIn || false}
                path={get(this.props, 'location.pathname')}
                reservationId={reservationId}
                systemData={get(this.props, 'data.systemData', {})}
                translations={get(this.props, 'data.translations', {})}
                unitLink={unitLink}
                bookingFlow={bookingFlow}
            />
        );
    };

    renderAppDownloadBanner = () => {
        return (
            <AppDownloadBanner
                path={get(this.props, 'location.pathname')}
                systemData={get(this.props, 'data.systemData', {})}
            />
        );
    };

    render() {
        const translations = get(this.props, 'data.translations', {});
        const systemData = get(this.props, 'data.systemData', {});
        const conversationMatch = matchPath(
            get(this.props, 'location.pathname', ''),
            '/traveler/th/inbox/conversation/:id'
        );
        const {isVrbexNative, isConfirmationToTID} = this.props;
        const conversationId = conversationMatch?.params?.id;

        const search = get(this.props, 'location.search', '');
        const params = new URLSearchParams(search);
        const tripViewId = params.get('tripViewId');
        const tripItemId = params.get('tripItemId');

        return (
            <div className="stay-ui-container">
                {/* --- Render App-Banner only for inbox routes --- */}
                {!isVrbexNative &&
                    !isConfirmationToTIDRedirect(
                        isConfirmationToTID,
                        tripViewId,
                        tripItemId
                    ) && (
                        <Route
                            path={'/traveler/th/'}
                            strict
                            render={this.renderAppDownloadBanner}
                        />
                    )}
                {!isVrbexNative &&
                    !isConfirmationToTIDRedirect(
                        isConfirmationToTID,
                        tripViewId,
                        tripItemId
                    ) && (
                        <Header
                            conversationId={conversationId}
                            systemData={systemData}
                            translations={translations}
                        />
                    )}
                <div className="stay-ui-body">
                    {/* --- Content (Routes) --- */}
                    <ScrollToTop />
                    <Route
                        path={'/traveler/th/inbox'}
                        exact
                        render={this.renderInbox}
                    />
                    <Route
                        path={'/traveler/th/inbox/conversation/:id'}
                        exact
                        render={this.renderConversation}
                    />
                    <Route
                        path={'/traveler/th/inbox/conversation/:id/:tab'}
                        exact
                        render={this.renderConversation}
                    />
                    <Route
                        path={'/traveler/th/inbox/conversation/:id/:tab/guests'}
                        exact
                        render={this.renderConversation}
                    />
                    <Route
                        path={'/traveler/th/bookings'}
                        exact
                        render={this.renderMyTrips}
                    />
                    <Route
                        path={'/traveler/th/confirmation'}
                        exact
                        render={this.renderConfirmation}
                    />
                    <Feedback
                        feedbackTabClassList={
                            'Feedback__tab btn btn-default hidden-xs'
                        }
                        lingua={{
                            externalLinkSrText: translate(
                                translations,
                                'ui-development/shared',
                                'stabFeedback',
                                'shared.stabFeedback.externalLinkSrText'
                            ),
                            helpLink: translate(
                                translations,
                                'ui-development/shared',
                                'stabFeedback',
                                'shared.stabFeedback.helpLink'
                            ),
                            helpLinkText: translate(
                                translations,
                                'ui-development/shared',
                                'stabFeedback',
                                'shared.stabFeedback.lookingForSupport'
                            ),
                            reviewLink: translate(
                                translations,
                                'ui-development/shared',
                                'stabFeedback',
                                'shared.stabFeedback.reviewLink'
                            ),
                            reviewLinkText: translate(
                                translations,
                                'ui-development/shared',
                                'stabFeedback',
                                'shared.stabFeedback.lookingToWriteReview'
                            ),
                            supportLinkText: translate(
                                translations,
                                'ui-development/shared',
                                'stabFeedback',
                                'shared.stabFeedback.leaveComment'
                            ),
                            tabText: translate(
                                translations,
                                'ui-development/shared',
                                'stabFeedback',
                                'shared.stabFeedback.tabText'
                            ),
                            title: translate(
                                translations,
                                'ui-development/shared',
                                'stabFeedback',
                                'shared.stabFeedback.tabText'
                            ),
                        }}
                        tabPosition={'right'}
                    />
                    <Toaster animation={'replace'} position={'top-right'} />
                </div>
                {!isVrbexNative &&
                    !isConfirmationToTIDRedirect(
                        isConfirmationToTID,
                        tripViewId,
                        tripItemId
                    ) && (
                        <Footer
                            systemData={get(this.props, 'data.systemData', {})}
                            data-testid={`footer`}
                        />
                    )}
            </div>
        );
    }
}

export const App = (props) => {
    const {isVrbexNative, isConfirmationToTID} = useContext(VrbexContext);
    return (
        <AppInternal
            {...props}
            isVrbexNative={isVrbexNative}
            isConfirmationToTID={isConfirmationToTID}
        />
    );
};

export default graphql(AppQuery)(App);
